<template>
  <div class="h-full overflow-auto">
    <TopBarComponent
      :left-image="{
        alt: 'AS3 Work and Care logo',
        source: onboardingBasePath + businessUnitLogo
      }"
      :right-image="{
        alt: 'Customer logo',
        source: onboardingBasePath + customerLogo
      }"
    />
    <div v-if="store.initialized === true" class="mt-0 md:mt-4">
      <div class="container mx-auto px-0 sm:px-6 lg:px-8">
        <RouterView />
      </div>
    </div>

    <div v-else class="flex h-screen content-center items-center justify-center">
      <SpinnerComponent class="h-8 w-8" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { useOnboardingStore } from '@/stores/onboarding-stores/onboardingStore'
import { storeToRefs } from 'pinia'

const store = useOnboardingStore()
const { customerLogo, businessUnitLogo, onboardingBasePath } = storeToRefs(store)

onMounted(async () => {
  store.init()
})
</script>
